App.registerBehavior('CookieConsentSettings', function (appSettings) {
  // Click on 'Edit settings' button
  $('[data-cookie-consent="revoke-consent"]').on('click', function () {
    window.consent.showBanner();
  });
});

